import { LockIcon, ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { GenericAvatarIcon, Heading, VStack } from "@chakra-ui/react";
import React, { useState } from "react";
import { Field, Form } from "react-final-form";
import InputField from "../../components/fields/InputField";
import { loginValidator as validate } from "./validators";

type LoginFormProps = {
  onSubmit: (...params: any) => void;
  formName?: string;
  initialValues?: any;
};

const LoginForm = (props: LoginFormProps) => {
  const { onSubmit, formName, initialValues } = props;
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Form onSubmit={onSubmit} validate={validate} initialValues={initialValues}>
      {(props) => (
        <form onSubmit={props.handleSubmit} id={formName}>
          <VStack spacing={5}>
            <Heading fontSize={"4xl"} fontWeight="bold" color="primary">
              FreeshU
            </Heading>

            <Field
              name="username"
              placeholder="Username"
              component={InputField}
              leftAddOn={GenericAvatarIcon}
            />
            <Field
              name="password"
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              component={InputField}
              rightIconClick={() =>
                setShowPassword((showPassword) => !showPassword)
              }
              rightAddOn={showPassword ? ViewIcon : ViewOffIcon}
              rightIconStyle={{
                bg: "none",
                cursor: "pointer",
              }}
              leftAddOn={LockIcon}
            />
          </VStack>
        </form>
      )}
    </Form>
  );
};

export default LoginForm;
